export default "__VITE_ASSET__C9Uk4lq4__"